import { getPathAndRepo } from './getPathAndRepo';
export function groupByRepository(files) {
    let groupFiles = [];
    const filesSelected = getPathAndRepo(files);
    filesSelected.map((file) => {
        const index = groupFiles.findIndex((item) => item?.repository === file.repository);
        if (index >= 0) {
            groupFiles[index]?.files.push(file.path);
        }
        else {
            groupFiles.push({
                files: [file.path],
                repository: file.repository,
            });
        }
        return groupFiles;
    });
    return groupFiles;
}
